const hasCoupon = professionalCoupon => {
  return professionalCoupon ? true : false;
};

const getProfessionalCoupon = coupon => {
  if (!coupon) {
    return "";
  }

  if (percentageDiscount(coupon.value_type)) {
    return `${coupon.value}% desconto`;
  }

  if (valueDiscount(coupon.value_type)) {
    return `R$ ${coupon.value / 100} desconto`;
  }
  return "";
};

const applyDiscount = (originalPrice, coupon) => {
  if (!coupon) {
    return originalPrice;
  }

  if (percentageDiscount(coupon.value_type)) {
    return originalPrice - (coupon.value / 100) * originalPrice;
  }

  if (valueDiscount(coupon.value_type)) {
    return originalPrice - coupon.value;
  }

  return originalPrice;
};

const percentageDiscount = discountType => {
  return discountType === "PERCENTAGE";
};

const valueDiscount = discountType => {
  return discountType === "VALUE";
};

export default {
  hasCoupon,
  getProfessionalCoupon,
  applyDiscount
};



// WEBPACK FOOTER //
// ./src/utils/helpers/coupon.js